import { ApiHelper } from '../../../../common/helpers/ApiHelper'

export const LOADING_LIVE_CHATBOT_OPTIONS = [{ key: '', label: 'Loading…' }]

function asList(data) {
  if (!data) return []
  if (Array.isArray(data)) return data
  if (Array.isArray(data.items)) return data.items
  if (Array.isArray(data.data)) return data.data
  return []
}

export function chatbotDisplayLabel(item) {
  const id = String((item && item.id) || '').trim()
  const name = String((item && (item.name || item.title)) || id).trim() || id
  if (!name) return ''
  if (String((item && item.state) || '').toUpperCase() === 'LIVE') return name
  return name + ' (DISABLED)'
}

export function chatbotLabelMap(items) {
  const map = {}
  const list = asList(items)
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    const id = String((item && item.id) || '').trim()
    if (!id) continue
    map[id] = chatbotDisplayLabel(item)
  }
  return map
}

export function liveChatbotSelectOptions(items, excludeId) {
  const skip = String(excludeId || '').trim()
  return asList(items)
    .filter(item => item && String(item.state || '').toUpperCase() === 'LIVE')
    .map(item => {
      const id = String(item.id || '').trim()
      if (!id || id === skip) return null
      return { key: id, label: chatbotDisplayLabel(item) }
    })
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
}

export function labelForChatbotId(options, chatbotId, labelMap) {
  const id = String(chatbotId || '').trim()
  if (!id) return ''
  if (labelMap && labelMap[id]) return labelMap[id]
  const list = options || []
  for (let i = 0; i < list.length; i++) {
    if (list[i] && list[i].key === id) return list[i].label || id
  }
  return id
}

export async function fetchLiveChatbots(ms, orgId) {
  const data = await ApiHelper.callAwait({
    ms,
    method: 'GET',
    paths: ['wacontents'],
    queryParams: { orgId, iType: 'CHATBOT' },
  })
  return asList(data)
}
